module.exports = __webpack_public_path__ + "img/LogoLife_3x.d3ee5a0d.png";